const percent = (value: string | undefined, fallback: number) => {
  const parsed = Number(value);
  return value?.trim() && Number.isInteger(parsed) && parsed >= 0 && parsed <= 20
    ? parsed
    : fallback;
};

export const FINALIZE_PERCENT = {
  ZM: {
    min: percent(process.env.REACT_APP_ZM_MIN_FINALIZE_PERCENT, 0),
    max: percent(process.env.REACT_APP_ZM_MAX_FINALIZE_PERCENT, 5),
  },
  BRANCH_HEAD: {
    min: percent(process.env.REACT_APP_BRANCH_HEAD_MIN_FINALIZE_PERCENT, 6),
    max: percent(process.env.REACT_APP_BRANCH_HEAD_MAX_FINALIZE_PERCENT, 15),
  },
  BRANCH_MANAGER: {
    min: percent(process.env.REACT_APP_BRANCH_MANAGER_MIN_FINALIZE_PERCENT, 16),
    max: percent(process.env.REACT_APP_BRANCH_MANAGER_MAX_FINALIZE_PERCENT, 20),
  },
};

export const getFinalizePolicy = (me: any, value: unknown) => {
  const range = me?.isBranchHead
    ? FINALIZE_PERCENT.BRANCH_HEAD
    : me?.permissions?.VALUATION_FINALIZE_CONFIRM?.hasAccess
      ? FINALIZE_PERCENT.BRANCH_MANAGER
      : me?.permissions?.VALUATION?.isCreate
        ? FINALIZE_PERCENT.ZM
        : undefined;
  const current = Number(value);
  const valid = value !== null && value !== undefined && Number.isInteger(current) &&
    current >= FINALIZE_PERCENT.ZM.min && current <= FINALIZE_PERCENT.BRANCH_MANAGER.max;
  return {
    canFinalize: !!me && !!range && valid && current >= range.min && current <= range.max,
    canForward: !!me && !!range && valid && current > range.max,
    forwardLabel: me?.isBranchHead || me?.permissions?.VALUATION_FINALIZE_CONFIRM?.hasAccess
      ? 'Зээлийн газар руу илгээх'
      : 'Салбарын захирал руу илгээх',
  };
};
